import { providerApi } from '@/api/ProviderApi'
import type { AppointmentResultReportResponse } from '@/api/types/ProviderApi'
import { useQuery } from '@tanstack/react-query'
import { isNil } from 'ramda'

export const useFetchLatestAppoinmentResults = () => {
	const { data = {} as AppointmentResultReportResponse, isLoading: isLoadingResults } =
		useQuery({
			queryKey: ['latest-patient-appointment-results'],
			queryFn: () => providerApi.fetchLatestAppointmentResults(),
			staleTime: 1000 * 60 * 2, // 2 minutes
		})

	return {
		appointmentResults: data?.results,
		hasLockedResults: data?.isLocked,
		appointmentId: data?.appointmentId,
		isLoadingResults,
		hasAppointmentResults: !isLoadingResults && !isNil(data?.results),
	}
}
